/**
 * Ela Wonen product page (configurator template). Drives sections/ela-pdp-*.liquid:
 * gallery + lightbox, size / gift / extras configurator, real cart add (Shopify standard
 * CartLinesUpdateEvent, so the header count and the theme cart drawer update), layer explorer,
 * size on scale, showroom opening status and the bottom buy bar.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const dataEl = document.getElementById('ep-data');
if (dataEl) init(JSON.parse(dataEl.textContent));

function init(D) {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const eur = (c) => { const r = Math.round(c); return r % 100 === 0 ? (r / 100).toLocaleString('nl-NL') + ',-' : (r / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  const norm = (t) => String(t || '').toLowerCase().replace(/cm/g, '').replace(/\s+/g, '');
  const dims = (t) => { const m = String(t || '').match(/(\d{2,3})\s*x\s*(\d{2,3})/i); return m ? { w: +m[1], l: +m[2] } : null; };
  const byId = Object.fromEntries(D.variants.map((v) => [String(v.id), v]));
  const cheapest = D.variants.reduce((a, b) => (b.price < a.price ? b : a));
  const minPrice = cheapest.price;
  const state = { variant: D.selected && byId[String(D.selected)] ? String(D.selected) : null, gift: D.gift ? (D.gifts[0] || {}).value : null, extras: {} };
  let adding = false;
  const go = (el, block = 'start') => el && el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block });
  const setText = (sel, t) => $$(sel).forEach((el) => { el.textContent = t; });
  let toastT;
  const toast = (m) => { const t = $('#ep-toast'); if (!t) return; t.textContent = m; t.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-on'), 2800); };

  // anchors and the sticky gallery stay clear of the store header while it is on screen
  const hdr = document.getElementById('ela-hdr'), rootStyle = document.documentElement.style;
  let padRaf = 0;
  const setTop = () => { padRaf = 0; const top = Math.round((hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0) + 16); rootStyle.setProperty('--ep-top', `${top}px`); rootStyle.scrollPaddingTop = `${top}px`; };
  setTop();
  // capture on document also catches scrolling of an inner page container, not only the window
  document.addEventListener('scroll', () => { if (!padRaf) padRaf = requestAnimationFrame(setTop); }, { passive: true, capture: true });
  window.addEventListener('resize', setTop);

  /* ---------- gallery + lightbox ---------- */
  const slides = $('#ep-slides'), imgs = $$('#ep-slides img'), rail = $$('#ep-rail button'), dots = $$('#ep-dots i');
  // photos 2+ only load once the visitor touches the gallery, which keeps the first page load light
  let hydrated = false;
  const hydrate = () => {
    if (hydrated) return;
    hydrated = true;
    imgs.forEach((im) => {
      if (!im.dataset.srcset) return;
      if (im.dataset.msrcset) im.before(Object.assign(document.createElement('source'), { media: '(max-width: 999px)', srcset: im.dataset.msrcset, sizes: '100vw' }));
      im.srcset = im.dataset.srcset;
      im.src = im.dataset.src;
      ['data-srcset', 'data-msrcset', 'data-src'].forEach((a) => im.removeAttribute(a));
    });
  };
  if (slides) {
    ['touchstart', 'pointerdown', 'focusin'].forEach((t) => slides.addEventListener(t, hydrate, { passive: true, once: true }));
    slides.addEventListener('scroll', hydrate, { passive: true, once: true });
  }
  [$('.ep-viewer'), $('#ep-rail')].forEach((el) => el?.addEventListener('mouseenter', hydrate, { once: true }));
  let idx = 0;
  const setIdx = (i) => { idx = i; setText('#ep-count', `${i + 1} / ${imgs.length}`); rail.forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false')); dots.forEach((d, k) => d.classList.toggle('on', k === i)); };
  const show = (i) => { if (!slides || !imgs.length) return; hydrate();i = (i + imgs.length) % imgs.length; slides.scrollTo({ left: i * slides.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); setIdx(i); };
  if (slides) {
    slides.addEventListener('scroll', () => { if (!slides.clientWidth) return; const i = Math.max(0, Math.min(imgs.length - 1, Math.round(slides.scrollLeft / slides.clientWidth))); if (i !== idx) setIdx(i); }, { passive: true });
    slides.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { show(idx + 1); e.preventDefault(); } if (e.key === 'ArrowLeft') { show(idx - 1); e.preventDefault(); } });
  }
  rail.forEach((b, k) => b.addEventListener('click', () => show(k)));
  $('#ep-prev')?.addEventListener('click', () => show(idx - 1));
  $('#ep-next')?.addEventListener('click', () => show(idx + 1));

  const lb = $('#ep-lb'), lbImg = $('#ep-lb-img'), lbFig = $('#ep-lb-fig');
  let lbI = 0, lastFocus = null;
  const big = (im) => im.getAttribute('data-full') || im.currentSrc || im.src;
  const lbSet = (i) => { lbI = (i + imgs.length) % imgs.length; lbImg.src = big(imgs[lbI]); lbImg.alt = imgs[lbI].alt; setText('#ep-lb-count', `${lbI + 1} / ${imgs.length}`); lbFig.classList.remove('is-zoom'); };
  // the theme scrolls .page-wrapper, so the lock goes on that container via a body class
  const lbOpen = (i) => { if (!lb || !imgs.length) return; lastFocus = document.activeElement; lbSet(i); lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false'); document.body.classList.add('ep-lock'); $('#ep-lb-x').focus(); };
  const lbClose = () => { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.body.classList.remove('ep-lock'); lastFocus?.focus(); };
  const origin = (e) => { const r = lbFig.getBoundingClientRect(); lbImg.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`; };
  if (lb) {
    imgs.forEach((im, k) => im.addEventListener('click', () => lbOpen(k)));
    $('#ep-zoom')?.addEventListener('click', () => lbOpen(idx));
    $('#ep-lb-x').addEventListener('click', lbClose);
    $('#ep-lb-prev').addEventListener('click', () => lbSet(lbI - 1));
    $('#ep-lb-next').addEventListener('click', () => lbSet(lbI + 1));
    lbFig.addEventListener('click', (e) => { origin(e); lbFig.classList.toggle('is-zoom'); });
    lbFig.addEventListener('mousemove', (e) => { if (lbFig.classList.contains('is-zoom')) origin(e); });
    lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      if (e.key === 'Tab') { // keep keyboard focus inside the open lightbox
        const f = ['#ep-lb-x', '#ep-lb-prev', '#ep-lb-next'].map((sel) => $(sel)), i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? f.length - 1 : 1) + f.length) % f.length].focus();
      }
      if (e.key === 'ArrowRight') lbSet(lbI + 1);
      if (e.key === 'ArrowLeft') lbSet(lbI - 1);
    });
  }

  /* ---------- configurator ---------- */
  const extraVariant = (ex) => {
    const vs = ex.variants.filter((v) => v.available);
    if (ex.variants.length === 1) return vs[0] || null;
    const cur = state.variant && byId[state.variant];
    const key = cur && norm(cur.title).match(/\d+x\d+/);
    return key ? vs.find((v) => norm(v.title).startsWith(key[0])) || null : null;
  };
  const total = () => {
    const v = state.variant && byId[state.variant];
    let t = v ? v.price : 0;
    D.extras.forEach((ex) => { if (state.extras[ex.key]) { const ev = extraVariant(ex); if (ev) t += ev.price; } });
    return t;
  };
  const klarnaOk = (c) => D.klarna && c >= D.kMin && c <= D.kMax;
  const third = (c) => eur(Math.round(c / 3));

  function render() {
    // an extra without the chosen size switches off before anything is counted
    D.extras.forEach((ex) => { if (state.extras[ex.key] && !extraVariant(ex)) state.extras[ex.key] = false; });
    const v = state.variant && byId[state.variant];
    const p = v ? v.price : minPrice, t = v ? total() : minPrice;
    const nEx = D.extras.filter((ex) => state.extras[ex.key]).length;
    const from = $('#ep-from'); if (from) from.hidden = !!v;
    setText('#ep-now', eur(p));
    const was = $('#ep-was'), save = $('#ep-save');
    // before a size is chosen the "vanaf" price shows the discount of the cheapest size
    const pv = v || cheapest, onSale = pv.compare > pv.price;
    if (was) { was.hidden = !onSale; if (onSale) was.textContent = eur(pv.compare); }
    if (save) { save.hidden = !onSale; if (onSale) save.textContent = `Bespaar ${eur(pv.compare - pv.price)}`; }
    const kl = $('#ep-kl'); if (kl) { kl.hidden = !klarnaOk(p); setText('#ep-kl-amt', `3 x ${third(p)}`); }
    const dkl = $('#ep-dkl'); if (dkl) { dkl.hidden = !klarnaOk(t); dkl.textContent = `of 3 x ${third(t)} met Klarna`; }
    $('#ep-st-size')?.classList.toggle('is-done', !!v);
    setText('#ep-st-size-val', v ? v.title : 'Nog niet gekozen');
    $('#ep-st-extra')?.classList.toggle('is-done', nEx > 0);
    setText('#ep-st-extra-val', nEx ? (nEx === 1 ? '1 extra' : `${nEx} extra’s`) : 'Optioneel');
    $$('input[name="ep-size"]').forEach((r) => { r.checked = r.value === state.variant; });
    const curV = byId[String(state.variant)];
    if (curV && curV.opts) $$('#ep-sizes input[data-opt]').forEach((r) => { r.checked = r.value === curV.opts[+r.dataset.opt]; });
    D.extras.forEach((ex) => {
      const row = document.getElementById(`ep-ex-${ex.key}`); if (!row) return;
      const ev = extraVariant(ex), on = !!state.extras[ex.key] && !!ev;
      if (state.extras[ex.key] && !ev) state.extras[ex.key] = false;
      const btn = row.querySelector('.ep-tg');
      row.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.querySelector('use').setAttribute('href', on ? '#ep-i-check' : '#ep-i-plus');
      btn.disabled = !ev && !!state.variant;
      const minEx = Math.min(...ex.variants.map((x) => x.price));
      row.querySelector('.ep-ex-p').textContent = ev ? eur(ev.price) : (state.variant ? 'Niet in deze maat' : `vanaf ${eur(minEx)}`);
      row.querySelector('.ep-ex-s').textContent = ev && ex.variants.length > 1 ? `${ex.note ? ex.note + ', ' : ''}${ev.title}` : ex.note;
    });
    const soldOut = !D.available || (!!v && !v.available);
    const label = soldOut ? 'Uitverkocht' : v ? 'In winkelwagen' : 'Kies je maat';
    ['#ep-atc', '#ep-bar-atc'].forEach((s) => { const b = $(s); if (b) { b.textContent = label; b.disabled = soldOut || adding; } });
    setText('.ep-tot-lbl', v ? 'Totaal' : 'Vanaf');
    setText('.ep-tot-val', eur(t));
    setText('#ep-bar-size', v ? v.title + (nEx ? ` met ${nEx === 1 ? '1 extra' : nEx + ' extra’s'}` : '') : 'Kies je maat');
    const ov = $('#ep-ov-list');
    if (ov) {
      ov.innerHTML = '';
      const li = (a, b) => { const e = document.createElement('li'); e.append(Object.assign(document.createElement('span'), { textContent: a }), Object.assign(document.createElement('b'), { textContent: b })); ov.appendChild(e); };
      li(v ? v.title : 'Maat nog kiezen', v ? eur(v.price) : '');
      if (D.gift && state.gift) li(`Cadeau: ${state.gift}`, 'Gratis');
      D.extras.forEach((ex) => { if (state.extras[ex.key]) { const ev = extraVariant(ex); if (ev) li(ex.title, eur(ev.price)); } });
      li('Bezorging tot aan de deur', t >= 50000 || !v ? 'Gratis' : eur(5000));
    }
    const msg = `${D.waText} ${D.title}${v ? ' in ' + v.title : ''}`;
    $$('.ep-wa-link').forEach((a) => {
      try { const u = new URL(a.href); const rest = (u.searchParams.get('text') || '').split('\n').slice(1).join('\n'); a.href = `${u.origin}${u.pathname}?text=${encodeURIComponent(msg + (rest ? '\n' + rest : ''))}`; } catch (_) {}
    });
    fitSync();
  }
  function pickVariant(id, quiet) {
    if (!byId[id]) return;
    state.variant = id;
    try { const u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(history.state, '', u); } catch (_) {}
    render();
    if (!quiet) toast(`Maat ${byId[id].title} gekozen`);
  }
  $$('input[name="ep-size"]').forEach((r) => r.addEventListener('change', () => pickVariant(r.value, true)));
  $$('#ep-sizes input[data-opt]').forEach((r) => r.addEventListener('change', () => {
    const k = +r.dataset.opt, base = (byId[String(state.variant)] || {}).opts;
    let v = null;
    if (base) { const want = base.slice(); want[k] = r.value; v = D.variants.find((x) => x.available && want.every((val, n) => x.opts[n] === val)); }
    if (!v) v = D.variants.find((x) => x.available && x.opts && x.opts[k] === r.value) || D.variants.find((x) => x.opts && x.opts[k] === r.value);
    if (v) pickVariant(String(v.id), true);
  }));
  $$('input[name="ep-gift"]').forEach((r) => r.addEventListener('change', () => { state.gift = r.value; render(); toast(`Cadeau gekozen: ${r.getAttribute('data-label') || r.value}`); }));
  $$('.ep-tg').forEach((b) => b.addEventListener('click', () => {
    const k = b.getAttribute('data-ex'), ex = D.extras.find((x) => x.key === k);
    if (!state.variant && ex.variants.length > 1) { needSize(); return; }
    state.extras[k] = !state.extras[k]; render();
    toast(`${ex.title} ${state.extras[k] ? 'toegevoegd' : 'verwijderd'}`);
  }));

  function needSize() {
    go($('#ep-st-size'), 'center');
    const g = $('#ep-sizes'); if (g) { g.classList.remove('is-nudge'); void g.offsetWidth; g.classList.add('is-nudge'); }
    toast('Kies eerst je maat');
  }

  /* ---------- add to the real cart ---------- */
  const errEl = $('#ep-err');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  async function addToCart(btn) {
    if (adding) return;
    const v = state.variant && byId[state.variant];
    if (!v) { needSize(); return; }
    if (!v.available) return;
    const items = [{ id: Number(v.id), quantity: 1 }];
    if (D.gift && state.gift) items[0].properties = { [D.giftKey]: state.gift };
    D.extras.forEach((ex) => { if (state.extras[ex.key]) { const ev = extraVariant(ex); if (ev) items.push({ id: Number(ev.id), quantity: 1 }); } });
    const sectionIds = $$('cart-items-component').map((el) => el.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    let settled = false;
    adding = true;
    const atcBtns = ['#ep-atc', '#ep-bar-atc'].map((sel) => $(sel)).filter(Boolean);
    atcBtns.forEach((b) => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    if (errEl) errEl.hidden = true;
    btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: deferred.promise }));
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: location.pathname }) });
      const data = await res.json();
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      const failed = !res.ok || !!data.status;
      settled = true;
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'ela-pdp', sourceId: 'ela-pdp', itemCount: items.length, productId: String(D.productId), sections: failed ? undefined : data.sections, didError: failed } });
      if (failed) throw new Error(data.description || data.message || '');
      const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
      setTimeout(() => { if (drawer && typeof drawer.open === 'function') { if (!drawer.isOpen) drawer.open(); } else { location.href = `${root}cart`; } }, 60);
    } catch (e) {
      if (!settled) deferred.reject(e);
      const msg = e.message || 'Toevoegen is niet gelukt. Probeer het opnieuw of stuur ons een WhatsApp bericht.';
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      toast(msg);
    } finally {
      adding = false;
      atcBtns.forEach((b) => b.removeAttribute('aria-busy'));
      render();
    }
  }
  ['#ep-atc', '#ep-bar-atc'].forEach((s) => $(s)?.addEventListener('click', (e) => addToCart(e.currentTarget)));

  /* ---------- layer explorer (isometric slabs, top layer first in the list) ---------- */
  const layerBtns = $$('#ep-layers button');
  const iso = $('#ep-iso');
  if (iso && layerBtns.length) {
    const C = 0.866, S = 0.5, W = 200, Dp = 150, ZONES = [30, 45, 35, 45, 45];
    const n = layerBtns.length;
    const kinds = layerBtns.map((b, i) => (i === 0 && n > 1 ? 'cover' : i === n - 1 ? 'core' : 'comfort'));
    const H = { cover: 9, comfort: 12, core: 34 };
    const COL = { cover: ['#fbfaf6', '#e7e2da', '#d9d2c7'], comfort: ['#efe5d2', '#dfd1b9', '#d1c2a7'], core: ['#d4d7d9', '#b9bdc0', '#a8acaf'] };
    const slabs = []; let z = 0;
    for (let i = n - 1; i >= 0; i--) { const k = kinds[i]; slabs.push({ i, k, z, h: H[k], lift: -(n - 1 - i) * 34, zones: layerBtns[i].dataset.zones === 'true' }); z += H[k]; }
    const topDetail = (s) => {
      let o = '';
      if (s.k === 'cover') {
        o += `<rect x="6" y="6" width="${W - 12}" height="${Dp - 12}" fill="none" stroke="rgba(0,0,0,.12)" stroke-width=".7"/>`;
        for (let x = 20; x < W; x += 20) o += `<path d="M${x} 6V${Dp - 6}" stroke="rgba(0,0,0,.06)" stroke-width=".6"/>`;
        for (let y = 18; y < Dp - 6; y += 18) o += `<path d="M6 ${y}H${W - 6}" stroke="rgba(0,0,0,.06)" stroke-width=".6"/>`;
        for (let x = 20; x < W; x += 20) for (let y = 18; y < Dp - 6; y += 18) o += `<circle cx="${x}" cy="${y}" r="1.3" fill="rgba(0,0,0,.13)"/>`;
      } else if (s.k === 'comfort') {
        for (let y = 8; y < Dp; y += 9) { let d = `M0 ${y}`; for (let i = 0; i < 20; i++) d += ` q5 ${i % 2 ? 2.5 : -2.5} 10 0`; o += `<path d="${d}" fill="none" stroke="rgba(120,95,50,.17)" stroke-width=".8"/>`; }
      } else {
        if (s.zones) { let x0 = 0; ZONES.forEach((zw, k) => { o += `<rect x="${x0}" width="${zw}" height="${Dp}" fill="${k % 2 ? '#c5c9cc' : '#d4d7d9'}"/>`; x0 += zw; }); }
        for (let x = 5; x < W; x += 10) for (let y = 5; y < Dp; y += 10) o += `<circle cx="${x}" cy="${y}" r="3.3" fill="rgba(255,255,255,.45)" stroke="rgba(0,0,0,.18)" stroke-width=".5"/>`;
      }
      return o;
    };
    const side = (s, len) => {
      let o = '';
      if (s.k === 'core') for (let x = 6; x < len; x += 8) o += `<path d="M${x} ${s.z + 4}V${s.z + s.h - 4}" stroke="rgba(0,0,0,.08)" stroke-width=".8"/>`;
      if (s.k === 'cover') o += `<path d="M0 ${s.z + s.h - 2}H${len}" stroke="rgba(0,0,0,.15)" stroke-width=".8"/>`;
      return o;
    };
    const line = ' stroke="rgba(0,0,0,.22)" stroke-width=".6"';
    let g = '';
    slabs.forEach((s) => {
      const [top, left, right] = COL[s.k], zt = s.z + s.h;
      const L = `<g transform="matrix(${C},${S},0,-1,${-C * Dp},${S * Dp})"><rect y="${s.z}" width="${W}" height="${s.h}" fill="${left}"${line}/>${side(s, W)}</g>`;
      const R = `<g transform="matrix(${-C},${S},0,-1,${C * W},${S * W})"><rect y="${s.z}" width="${Dp}" height="${s.h}" fill="${right}"${line}/>${side(s, Dp)}</g>`;
      const T = `<g transform="matrix(${C},${S},${-C},${S},0,${-zt})"><rect width="${W}" height="${Dp}" fill="${top}"${line}/>${topDetail(s)}</g>`;
      const bx = C * (W - Dp / 2), by = S * (W + Dp / 2) - (s.z + s.h / 2);
      const badge = `<circle cx="${bx}" cy="${by}" r="8.5" fill="#161513" stroke="#f3efe8" stroke-width="1.2"/><text x="${bx}" y="${by + 3.2}" text-anchor="middle" font-size="9" font-weight="700" fill="#f3efe8" font-family="Montserrat,Arial,sans-serif">${s.i + 1}</text>`;
      g += `<g class="ep-lyr" data-i="${s.i}" style="transform:translateY(${s.lift}px)"><g filter="url(#ep-lsh)">${L}${R}${T}</g>${badge}</g>`;
    });
    const topY = -z - (n - 1) * 34 - 30;
    iso.innerHTML = `<svg viewBox="-145 ${topY} 335 ${190 - topY}" role="img" aria-label="Schematische opbouw in ${n} lagen"><defs><filter id="ep-lsh" x="-20%" y="-30%" width="140%" height="180%"><feDropShadow dx="0" dy="10" stdDeviation="8" flood-color="#000" flood-opacity=".5"/></filter></defs>${g}</svg>`;
    const setLayer = (i) => {
      layerBtns.forEach((b, k) => b.setAttribute('aria-expanded', k === i ? 'true' : 'false'));
      $$('.ep-lyr', iso).forEach((el) => { const s = slabs.find((x) => x.i === +el.dataset.i), on = s.i === i; el.classList.toggle('on', on); el.style.transform = `translateY(${s.lift + (on ? -12 : 0)}px)`; });
    };
    layerBtns.forEach((b, k) => b.addEventListener('click', () => setLayer(k)));
    iso.addEventListener('click', (e) => { const el = e.target.closest('.ep-lyr'); if (el) setLayer(+el.dataset.i); });
    $$('[data-ep-layer]').forEach((b) => b.addEventListener('click', () => { setLayer(Math.max(0, Math.min(n - 1, +b.dataset.epLayer - 1))); go($('#ep-opbouw')); }));
    setLayer(0);
  } else if (!$('#ep-kenmerken')) {
    $$('.ep-hl').forEach((el) => { el.hidden = true; });
  }

  /* ---------- size on scale ---------- */
  const fit = $('#ep-fitsvg');
  const fitAll = D.variants.map((v) => ({ id: String(v.id), title: v.title, d: dims(v.title), opts: v.opts || [], available: v.available })).filter((v) => v.d);
  const multiOpt = D.variants.some((v) => (v.opts || []).length > 1);
  const sizeIdx = multiOpt ? Math.max(0, (fitAll[0] ? fitAll[0].opts.findIndex((o) => dims(o)) : 0)) : 0;
  const sizeKey = (v) => `${v.d.w}x${v.d.l}`;
  const fitVariants = [];
  fitAll.forEach((v) => { if (!fitVariants.some((x) => sizeKey(x) === sizeKey(v))) fitVariants.push(Object.assign({}, v, { title: multiOpt ? sizeKey(v).replace('x', ' x ') : v.title })); });
  // clicking a size keeps the other options (model, colour) where that combination exists
  const pickSize = (key) => {
    const cur = byId[String(state.variant)], same = fitAll.filter((v) => sizeKey(v) === key);
    let v = null;
    if (cur && cur.opts && multiOpt) v = same.find((x) => x.available && x.opts.every((val, n) => n === sizeIdx || val === cur.opts[n]));
    v = v || same.find((x) => x.available) || same[0];
    if (v) pickVariant(v.id);
  };
  let fitSync = () => {};
  if (fit && fitVariants.length) {
    const NS = 'http://www.w3.org/2000/svg', K = 1.1, CX = 160, Y0 = 52, FONT = 'Montserrat,Arial,sans-serif';
    const mk = (tag, a) => { const e = document.createElementNS(NS, tag); Object.entries(a).forEach(([k, v]) => e.setAttribute(k, v)); fit.appendChild(e); return e; };
    const fHead = mk('rect', { y: Y0 - 16, height: 10, rx: 3, fill: '#d9d0c2' });
    const fMat = mk('rect', { y: Y0, rx: 7, fill: '#fff', stroke: '#cfc5b6', 'stroke-width': 1.2 });
    const fP = [0, 1].map(() => ({ pil: mk('rect', { y: Y0 + 8, height: 26 * K, rx: 6, fill: '#f7f3ec', stroke: '#dcd2c3', 'stroke-width': 1 }), sh: mk('rect', { y: Y0 + 40 * K, height: 36 * K, rx: 16 * K, fill: '#d5c9b7' }) }));
    const fDuv = mk('rect', { y: Y0 + 58 * K, rx: 6, fill: '#ece4d6' });
    const fFold = mk('rect', { y: Y0 + 58 * K, height: 12 * K, rx: 6, fill: '#e2d8c7' });
    const fH = [0, 1].map(() => mk('circle', { cy: Y0 + 22 * K, r: 9 * K, fill: '#c8b9a2' }));
    const fL = [0, 1].map(() => mk('text', { 'text-anchor': 'middle', 'font-size': 10, 'font-weight': 600, fill: '#8b8378', 'font-family': FONT }));
    const fDimT = mk('path', { stroke: '#1b1a18', 'stroke-width': 1, fill: 'none' });
    const fDimTx = mk('text', { x: CX, y: Y0 - 32, 'text-anchor': 'middle', 'font-size': 12, 'font-weight': 700, fill: '#1b1a18', 'font-family': FONT });
    const fDimR = mk('path', { stroke: '#1b1a18', 'stroke-width': 1, fill: 'none' });
    const fDimRx = mk('text', { 'text-anchor': 'middle', 'font-size': 12, 'font-weight': 700, fill: '#1b1a18', 'font-family': FONT });
    const draw = (Wc, Lc) => {
      const w = Wc * K, x = CX - w / 2, LEN = Lc * K, two = Wc >= 140, cs = two ? [x + w / 4, x + 3 * w / 4] : [CX];
      fit.setAttribute('viewBox', `0 0 320 ${Y0 + LEN + 26}`);
      fHead.setAttribute('x', x - 6); fHead.setAttribute('width', w + 12);
      fMat.setAttribute('x', x); fMat.setAttribute('width', w); fMat.setAttribute('height', LEN);
      [fDuv, fFold].forEach((e) => { e.setAttribute('x', x + 3); e.setAttribute('width', w - 6); });
      fDuv.setAttribute('height', LEN - 58 * K - 4);
      [0, 1].forEach((i) => {
        const on = i < cs.length, c = cs[i] || CX;
        fP[i].pil.setAttribute('x', c - 26 * K); fP[i].pil.setAttribute('width', 52 * K);
        fP[i].sh.setAttribute('x', c - 22 * K); fP[i].sh.setAttribute('width', 44 * K);
        fH[i].setAttribute('cx', c); fL[i].setAttribute('x', c); fL[i].setAttribute('y', Y0 + LEN - 12); fL[i].textContent = `${Math.round(two ? Wc / 2 : Wc)} cm`;
        [fP[i].pil, fP[i].sh, fH[i], fL[i]].forEach((e) => { e.style.display = on ? '' : 'none'; });
      });
      fDimT.setAttribute('d', `M${x} ${Y0 - 24}H${x + w}M${x} ${Y0 - 28}v8M${x + w} ${Y0 - 28}v8`);
      fDimTx.textContent = `${Math.round(Wc)} cm`;
      const rx = x + w + 14, my = Y0 + LEN / 2;
      fDimR.setAttribute('d', `M${rx} ${Y0}V${Y0 + LEN}M${rx - 4} ${Y0}h8M${rx - 4} ${Y0 + LEN}h8`);
      fDimRx.setAttribute('x', rx + 14); fDimRx.setAttribute('y', my); fDimRx.setAttribute('transform', `rotate(90 ${rx + 14} ${my})`); fDimRx.textContent = `${Lc} cm`;
    };
    const wrap = $('#ep-fit-sizes');
    fitVariants.forEach((v) => { const b = document.createElement('button'); b.type = 'button'; b.textContent = v.title; b.dataset.id = v.id; b.dataset.size = sizeKey(v); b.setAttribute('aria-pressed', 'false'); b.addEventListener('click', () => pickSize(b.dataset.size)); wrap.appendChild(b); });
    const preview = fitVariants.find((v) => v.d.w === 160) || fitVariants[Math.floor(fitVariants.length / 2)];
    let curW = preview.d.w, raf = 0;
    draw(curW, preview.d.l);
    fitSync = () => {
      const cur = fitAll.find((v) => v.id === state.variant);
      const chosen = cur ? fitVariants.find((v) => sizeKey(v) === sizeKey(cur)) : null, v = chosen || preview, two = v.d.w >= 140;
      $$('#ep-fit-sizes button').forEach((b) => b.setAttribute('aria-pressed', chosen && b.dataset.size === sizeKey(chosen) ? 'true' : 'false'));
      setText('#ep-ff-w', `${v.d.w} cm`); setText('#ep-ff-pp', `${two ? v.d.w / 2 : v.d.w} cm`);
      setText('#ep-ff-n', two ? '2' : '1'); setText('#ep-ff-nl', two ? 'personen' : 'persoon');
      const tip = two ? `Samen slapen op ${v.d.w / 2} cm per persoon.` : (v.d.w <= 90 ? 'Klassieke eenpersoonsmaat.' : `Een persoon, met ${v.d.w - 90} cm extra ruimte ten opzichte van 90 cm.`);
      setText('#ep-fit-tip', tip + (chosen ? '' : ' Tik op een maat om hem te kiezen.'));
      setText('#ep-fit-cap', `${chosen ? 'Jouw keuze' : 'Voorbeeld'}: ${v.title}, bovenaanzicht op schaal`);
      if (reduce) { curW = v.d.w; draw(curW, v.d.l); return; }
      cancelAnimationFrame(raf);
      const from = curW, t0 = performance.now();
      const step = (now) => { const p = Math.min(1, (now - t0) / 420), e = 1 - Math.pow(1 - p, 3); curW = from + (v.d.w - from) * e; draw(curW, v.d.l); if (p < 1) raf = requestAnimationFrame(step); };
      raf = requestAnimationFrame(step);
    };
  } else if ($('#ep-maten')) {
    $('#ep-maten').hidden = true;
  }

  /* ---------- feature explorer: the product photo follows the chosen feature ---------- */
  const featSec = $('#ep-kenmerken'), featList = $('#ep-feats');
  if (featSec && featList) {
    if (featSec.dataset.epAuto && !featList.children.length) {
      // no blocks set in the theme editor: move the headings out of the product description into this
      // list, so the same text is shown once, in a nicer place, and nothing is duplicated or lost
      const skip = /bezorg|lever|garantie|retour|bestell|kopen bij|showroom|prijs|betal|over ela|afmeting|maten/i;
      const rte = $('#ep-rte');
      const generic = /^(onderhoud( van (het blad|de stof))?|bekleding en onderhoud|combineren|vergelijken en combineren|kenmerken|plaatsing|waar let je op|compleet maken|specificaties)$/i;
    const okTitle = (t) => t.length > 5 && t.length < 70 && !skip.test(t) && !generic.test(t);
      // bold lines used as headings, common in the older Enza texts
      const bolds = () => $$('#ep-rte strong, #ep-rte b').filter((el) => {
        if (el.querySelector('a')) return false;
        const t = el.textContent.replace(/\s+/g, ' ').trim().replace(/[:.]+$/, ''), host = el.parentElement;
        return okTitle(t) && host && host.textContent.replace(/\s+/g, ' ').trim().startsWith(el.textContent.replace(/\s+/g, ' ').trim());
      });
      // collect without moving anything: with fewer than two features the section stays hidden,
      // and anything already moved into it would disappear from the page
      const collect = (heads) => {
        const isHead = (n) => heads.indexOf(n) > -1 || heads.some((h) => h !== n && n.contains && n.contains(h));
        const out = [];
        heads.forEach((h) => {
          if (out.length >= 4) return;
          const title = h.textContent.replace(/\s+/g, ' ').trim().replace(/[:.]+$/, '');
          if (!okTitle(title)) return;
          // for a bold line the paragraph around it is the heading, so start after that paragraph
          const solo = (h.tagName === 'STRONG' || h.tagName === 'B') && h.parentElement !== rte && h.parentElement.textContent.replace(/\s+/g, ' ').trim() === h.textContent.replace(/\s+/g, ' ').trim();
          const anchor = solo ? h.parentElement : h;
          const body = [];
          let chars = 0, n = anchor.nextSibling;
          // walk plain nodes too: these descriptions often have bare text between the bold lines
          while (n && !(n.nodeType === 1 && isHead(n))) {
            const next = n.nextSibling;
            if (n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim())) { body.push(n); chars += n.textContent.length; }
            n = next;
          }
          if (chars < 40) return;
          out.push({ title, anchor, body });
        });
        return out;
      };
      // judge on usable features, not on how many heading tags exist: a page can have two headings
      // where one is a 98 character marketing line, and still have five perfect bold headings
      const subs = $$('#ep-rte h3');
      let found = collect(subs.length >= 2 ? subs : $$('#ep-rte h2, #ep-rte h3'));
      if (found.length < 2 && rte) { const alt = collect(bolds()); if (alt.length > found.length) found = alt; }
      if (found.length >= 2) {
        found.forEach((f, i) => {
          const li = document.createElement('li'), btn = document.createElement('button');
          if (!i) li.className = 'on';
          btn.type = 'button'; btn.dataset.shot = String(i + 2); btn.setAttribute('aria-expanded', i ? 'false' : 'true');
          const num = document.createElement('span'); num.className = 'ep-ln'; num.textContent = String(i + 1);
          const box = document.createElement('span');
          const t = document.createElement('span'); t.className = 'ep-lt'; t.textContent = f.title;
          const d = document.createElement('div'); d.className = 'ep-ld';
          f.body.forEach((node) => {
            if (node.nodeType === 3) { const par = document.createElement('p'); par.textContent = node.textContent.trim(); node.remove(); d.appendChild(par); }
            else d.appendChild(node);
          });
          box.appendChild(t); btn.append(num, box); li.append(btn, d); featList.appendChild(li);
          f.anchor.remove();
        });
      }
    }
    const featBtns = $$('#ep-feats button'), shots = $$('#ep-shot img');
    if (featBtns.length >= 2) {
      featSec.hidden = false;
      const setFeat = (i) => {
        featBtns.forEach((b, k) => { const on = k === i; b.setAttribute('aria-expanded', on ? 'true' : 'false'); b.parentElement.classList.toggle('on', on); });
        if (!shots.length) return;
        const want = Math.min(shots.length, Math.max(1, parseInt(featBtns[i].dataset.shot, 10) || i + 1));
        shots.forEach((im) => im.classList.toggle('on', +im.dataset.i === want));
      };
      featBtns.forEach((b, k) => b.addEventListener('click', () => setFeat(k)));
      $$('[data-ep-layer]').forEach((b) => b.addEventListener('click', () => { setFeat(Math.max(0, Math.min(featBtns.length - 1, +b.dataset.epLayer - 1))); go(featSec); }));
      setFeat(0);
    } else {
      featSec.hidden = true;
      $$('.ep-hl').forEach((el) => { el.hidden = true; });
    }
  }

  /* ---------- afmetingen op schaal: the product next to a person of 1,80 m ---------- */
  const roomSec = $('#ep-ruimte'), roomSvg = $('#ep-roomsvg');
  if (roomSec && roomSvg) {
    const cfg = (() => { try { return JSON.parse($('#ep-room-data').textContent); } catch (e) { return {}; } })();
    const toCm = (s) => { const m = String(s).match(/(\d+(?:[.,]\d+)?)/); return m ? Math.round(parseFloat(m[1].replace(',', '.'))) : null; };
    const rows = (cfg.dims || []).map((s) => { const i = String(s).indexOf(':'); return i > 0 ? { l: String(s).slice(0, i).trim(), v: String(s).slice(i + 1).trim() } : null; }).filter(Boolean);
    const pick = (re) => { const r = rows.find((x) => re.test(x.l)); return r ? toCm(r.v) : null; };
    let W = pick(/^breedte\s*$/i) || pick(/^breedte\b/i);
    let Dp = pick(/^diepte\s*$/i) || pick(/^diepte\b/i);
    let H = pick(/^hoogte\s*$/i) || pick(/^hoogte\b/i);
    if (!W || !Dp || !H) {
      // fall back to a line like "Afmetingen: 275 x 166 x 81 cm" in the description
      const m = (($('#ep-rte') || {}).textContent || '').replace(/\s+/g, ' ').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*[x×]\s*(\d{2,3})\s*cm/i);
      if (m) { W = W || +m[1]; Dp = Dp || +m[2]; H = H || +m[3]; }
    }
    if (W && (Dp || H)) {
      const NS = 'http://www.w3.org/2000/svg', FONT = 'Montserrat,Arial,sans-serif';
      const INK = '#1b1a18', LINE = '#cfc5b6', PAPER = '#fff', GRID = 'rgba(27,26,24,.09)', SKIN = '#c8b9a2', BODY = '#d5c9b7';
      const extW = +cfg.ext > W ? +cfg.ext : 0, clear = +cfg.clear || 0, chairs = cfg.seats === true && !!Dp;
      let u = 1;
      const add = (tag, a, text) => { const e = document.createElementNS(NS, tag); Object.entries(a).forEach(([k, v]) => e.setAttribute(k, v)); if (text != null) e.textContent = text; roomSvg.appendChild(e); return e; };
      const label = (x, y, t, size, weight, fill, rot) => add('text', Object.assign({ x, y, 'text-anchor': 'middle', 'font-size': u * (size || 12), 'font-weight': weight || 700, fill: fill || INK, 'font-family': FONT }, rot ? { transform: `rotate(${rot} ${x} ${y})` } : {}), t);
      const grid = (w, h) => { for (let x = 0; x <= w; x += 50) add('path', { d: `M${x} 0V${h}`, stroke: GRID, 'stroke-width': u * 0.5 }); for (let y = 0; y <= h; y += 50) add('path', { d: `M0 ${y}H${w}`, stroke: GRID, 'stroke-width': u * 0.5 }); };
      const dimH = (x1, x2, y, t) => { add('path', { d: `M${x1} ${y}H${x2}M${x1} ${y - 7}v14M${x2} ${y - 7}v14`, stroke: INK, 'stroke-width': u * 0.9, fill: 'none' }); label((x1 + x2) / 2, y - u * 9, t); };
      const dimV = (y1, y2, x, t) => { add('path', { d: `M${x} ${y1}V${y2}M${x - 7} ${y1}h14M${x - 7} ${y2}h14`, stroke: INK, 'stroke-width': u * 0.9, fill: 'none' }); label(x + u * 13, (y1 + y2) / 2, t, 12, 700, INK, 90); };
      const seatCount = (w, d) => Math.max(0, 2 * Math.floor(w / 60)) + Math.max(0, 2 * Math.floor(d / 60));

      const drawPlan = () => {
        const ch = chairs ? 62 : 0;
        const objW = extW || W;
        const padT = 48 + ch + (extW ? 26 : 0), padL = 28 + ch, padR = 88 + ch, padB = (clear ? clear + 14 : 0) + 96 + ch;
        const sw = objW + padL + padR, sh = Dp + padT + padB;
        u = sw / 320;
        roomSvg.setAttribute('viewBox', `0 0 ${sw} ${sh}`);
        grid(sw, sh);
        const y0 = padT, ox = padL + (extW ? (extW - W) / 2 : 0);
        if (clear) {
          add('rect', { x: ox, y: y0 + Dp, width: W, height: clear, fill: 'rgba(27,26,24,.05)', stroke: INK, 'stroke-width': u * 0.8, 'stroke-dasharray': `${u * 5} ${u * 4}` });
          label(ox + W / 2, y0 + Dp + clear / 2 + u * 4, `${clear} cm ${cfg.clearLabel || 'vrije ruimte'}`, 11, 600, '#736e66');
        }
        if (chairs) {
          const nT = Math.floor(W / 60), nS = Math.floor(Dp / 60);
          const seat = (cx, cy, rot) => add('rect', { x: cx - 22, y: cy - 20, width: 44, height: 40, rx: 9, fill: '#ece6dc', stroke: LINE, 'stroke-width': u * 0.8, transform: `rotate(${rot} ${cx} ${cy})` });
          for (let i = 0; i < nT; i++) { const cx = ox + W * (i + 0.5) / nT; seat(cx, y0 - 30, 0); seat(cx, y0 + Dp + 30, 180); }
          const sx1 = (extW ? padL : ox) - 30, sx2 = (extW ? padL + extW : ox + W) + 30;
          for (let i = 0; i < nS; i++) { const cy = y0 + Dp * (i + 0.5) / nS; seat(sx1, cy, 90); seat(sx2, cy, 270); }
        }
        if (extW) add('rect', { x: padL, y: y0, width: extW, height: Dp, rx: 6, fill: 'none', stroke: INK, 'stroke-width': u * 0.9, 'stroke-dasharray': `${u * 5} ${u * 4}` });
        add('rect', { x: ox, y: y0, width: W, height: Dp, rx: 6, fill: PAPER, stroke: LINE, 'stroke-width': u * 1.3 });
        const pcx = padL + objW / 2, py = y0 + Dp + (clear ? clear + 14 : 0) + (chairs ? ch : 0) + 44;
        add('ellipse', { cx: pcx, cy: py, rx: 23, ry: 13, fill: BODY });
        add('circle', { cx: pcx, cy: py, r: 10, fill: SKIN });
        label(pcx, py + u * 26, 'persoon 1,80 m', 10, 600, '#736e66');
        dimH(ox, ox + W, y0 - ch - 22, `${W} cm`);
        if (extW) dimH(padL, padL + extW, y0 - ch - 46, `${extW} cm ${cfg.extLabel || 'uitgeschoven'}`);
        dimV(y0, y0 + Dp, ox + W + ch + 30, `${Dp} cm`);
        setText('#ep-room-cap', 'Bovenaanzicht op schaal');
      };

      const drawFront = () => {
        const objH = H || 80, gap = 58, pw = 56;
        const padT = 40, padL = 28, padR = 74, padB = 54;
        const sceneH = Math.max(objH, 180);
        const sw = W + gap + pw + padL + padR, sh = sceneH + padT + padB;
        u = sw / 320;
        roomSvg.setAttribute('viewBox', `0 0 ${sw} ${sh}`);
        grid(sw, sh);
        const base = padT + sceneH;
        add('path', { d: `M0 ${base}H${sw}`, stroke: INK, 'stroke-width': u * 1.4 });
        add('rect', { x: padL, y: base - objH, width: W, height: objH, rx: 5, fill: PAPER, stroke: LINE, 'stroke-width': u * 1.3 });
        const cx = padL + W + gap + pw / 2;
        add('circle', { cx, cy: base - 163, r: 12, fill: SKIN });
        add('path', { d: `M${cx - 21} ${base - 146} q21 -12 42 0 L${cx + 17} ${base - 92} L${cx + 16} ${base} L${cx + 3} ${base} L${cx + 1} ${base - 78} L${cx - 1} ${base - 78} L${cx - 3} ${base} L${cx - 16} ${base} L${cx - 17} ${base - 92} Z`, fill: BODY });
        label(cx, base + u * 17, '1,80 m', 10, 600, '#736e66');
        dimH(padL, padL + W, base + u * 20, `${W} cm`);
        dimV(base - objH, base, padL + W + 26, `${objH} cm`);
        setText('#ep-room-cap', 'Vooraanzicht op schaal');
      };

      const draw = (v) => { roomSvg.textContent = ''; if (v === 'front' && H) drawFront(); else drawPlan(); };
      const views = $$('#ep-room-views button');
      views.forEach((b) => {
        const v = b.dataset.view;
        if ((v === 'plan' && !Dp) || (v === 'front' && !H)) { b.hidden = true; return; }
        b.addEventListener('click', () => { views.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false')); draw(v); });
      });
      const start = Dp ? 'plan' : 'front';
      views.forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === start ? 'true' : 'false'));
      if (views.filter((b) => !b.hidden).length < 2) views.forEach((b) => { b.hidden = true; });
      draw(start);

      const facts = [];
      if (W) facts.push([`${W} cm`, extW ? 'breed (dicht)' : 'breed']);
      if (Dp) facts.push([`${Dp} cm`, 'diep']);
      if (H) facts.push([`${H} cm`, 'hoog']);
      const fbox = $('#ep-room-facts');
      facts.slice(0, 3).forEach((f) => {
        const d = document.createElement('div'), b = document.createElement('b'), s = document.createElement('span');
        b.className = 'ep-num'; b.textContent = f[0]; s.textContent = f[1]; d.append(b, s); fbox.appendChild(d);
      });
      const rest = rows.filter((r) => !/^(breedte|diepte|hoogte)\s*$/i.test(r.l));
      if (rest.length) {
        const ul = $('#ep-room-more'); ul.hidden = false;
        rest.slice(0, 6).forEach((r) => { const li = document.createElement('li'); li.textContent = `${r.l}: ${r.v}`; ul.appendChild(li); });
      }
      let tip;
      if (chairs) {
        const n = seatCount(W, Dp);
        tip = `Er zitten ${n} personen aan deze tafel, gerekend met 60 cm per persoon.`;
        if (extW) tip += ` Uitgeschoven naar ${extW} cm zijn dat er ${seatCount(extW, Dp)}.`;
      } else if (clear) {
        tip = `Naast de ${W} cm breedte houd je voor de kast ${clear} cm vrij ${cfg.clearLabel || 'als vrije ruimte'}.`;
      } else {
        tip = `${W} bij ${Dp || H} cm${Dp && H ? `, ${H} cm hoog` : ''}. De persoon in de tekening is 1,80 m.`;
      }
      setText('#ep-room-tip', tip);
      roomSec.hidden = false;
    }
  }

  /* ---------- delivery window (only when enabled in the theme editor) ---------- */
  if (D.eta && D.eta.on) {
    const A = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).forEach((p) => { A[p.type] = p.value; });
    const today = new Date(Date.UTC(+A.year, +A.month - 1, +A.day, 12));
    const plus = (n) => { const d = new Date(today.getTime()); d.setUTCDate(d.getUTCDate() + n); if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1); return d; };
    const f = (d) => d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).replace(/\./g, '');
    const a = f(plus(D.eta.min)), b = f(plus(D.eta.max));
    setText('#ep-eta-txt', `Verwachte levering tussen ${a} en ${b}`);
    $$('[data-ep-eta]').forEach((el) => { el.textContent = `${a} tot ${b}`; });
  }

  /* ---------- showroom open now ---------- */
  const st = $('#ep-status');
  if (st) {
    const A = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date()).forEach((p) => { A[p.type] = p.value; });
    const sun = A.weekday === 'Sun', mon = A.weekday === 'Mon', now = ((+A.hour) % 24) * 60 + (+A.minute);
    const hm = (v) => { const p = String(v || '').split(':'); return (+p[0] || 0) * 60 + (+p[1] || 0); }, fmt = (v) => (String(v).indexOf(':') < 0 ? v + ':00' : v);
    const openFor = (d) => (d === 'Sun' ? st.dataset.sun : d === 'Mon' ? (st.dataset.mon || st.dataset.week) : st.dataset.week), nextDay = { Mon: 'Tue', Tue: 'Wed', Wed: 'Thu', Thu: 'Fri', Fri: 'Sat', Sat: 'Sun', Sun: 'Mon' };
    const openT = openFor(A.weekday), open = hm(openT), close = hm(st.dataset.close);
    if (now >= open && now < close) st.textContent = `Nu open, tot ${fmt(st.dataset.close)}`;
    else { st.classList.add('is-closed'); st.textContent = now < open ? `Gesloten, opent vandaag om ${fmt(openT)}` : `Gesloten, opent morgen om ${fmt(openFor(nextDay[A.weekday]))}`; }
    const row = $(sun ? '#ep-h-zo' : mon && $('#ep-h-ma') ? '#ep-h-ma' : '#ep-h-mz');
    if (row) row.querySelector('dt').appendChild(Object.assign(document.createElement('span'), { className: 'ep-today', textContent: 'Vandaag' }));
  }

  /* ---------- description: long text folds open ---------- */
  const rte = $('#ep-rte'), more = $('#ep-more');
  if (rte && more && rte.scrollHeight > 560) {
    rte.classList.add('is-clamped'); more.hidden = false;
    more.addEventListener('click', () => { const open = rte.classList.toggle('is-clamped') === false; more.textContent = open ? 'Minder tonen' : 'Lees verder'; more.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }

  /* ---------- section links + bottom buy bar ---------- */
  const navTargets = $$('[data-ep-nav]').filter((s) => !s.hidden && s.id);
  ['#ep-jump', '#ep-bar-nav'].forEach((sel) => { const box = $(sel); if (!box) return; navTargets.forEach((s) => box.appendChild(Object.assign(document.createElement('a'), { href: `#${s.id}`, textContent: s.dataset.epNav }))); });
  // The bar shows once the price has scrolled away, and hides while the summary with its own buy button is in view.
  const bar = $('#ep-bar'), head = $('#ep-config .ep-price'), dock = $('#ep-dock');
  if ('IntersectionObserver' in window && bar && head && dock) {
    let headPast = false, dockSeen = true;
    const sync = () => {
      const on = headPast && !dockSeen;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('a,button', bar).forEach((el) => { el.tabIndex = on ? 0 : -1; });
    };
    const io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.target === head) headPast = !e.isIntersecting && e.boundingClientRect.top < 0; else dockSeen = e.isIntersecting; }); sync(); });
    io.observe(head); io.observe(dock);
    const links = $$('#ep-bar-nav a');
    const spy = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) links.forEach((a) => a.classList.toggle('on', a.getAttribute('href') === `#${e.target.id}`)); }), { rootMargin: '-45% 0px -50% 0px' });
    navTargets.forEach((s) => spy.observe(s));
  }

  render();
}
